/**
 * Configuration for jobs in this app.
 */
const jobiqoJobsConfig = require('./../src/jobiqo/config/jobs');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

module.exports = mergeDeepRight(jobiqoJobsConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    SHOW_EXPIRATION_DATE: true,
    ALLOWED_JOB_TYPES: ['job_per_template'],
    GEO_INFO: {
      radius: {
        unit: 'mi',
        unitMultiplier: 1.6,
        defaultValue: 25,
      },
      fixtures: [],
    },
    JOB_ALERT: {
      MODAL: {
        APPLICABLE_JOB_APPLICATION_WORKFLOW: ['external', 'internal'],
        FREQUENCY_DAYS: 10,
      },
      ignoreFields: ['notify_interval'],
      popup: {
        notifyIntervalValues: null,
      },
    },
    JOB_TRACKING_PIXEL_ENABLED: true,
    JOB_TRACKING_PIXEL_WITH_REQUIRED_FROM_QUERY_PARAMS: ['wjClickID'],
    AI: {
      JOB_DESCRIPTION: {
        enabled: true,
      },
    },
  }
});
